import React, { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSurveyStatus } from "../hooks/useSurveyStatus";

/** Wrap lesson content for the baseline gate only. */
export function SurveyGate({children}:{children:React.ReactNode}) {
  const {status,scope,loading,error,refetch}=useSurveyStatus();
  const location=useLocation();
  const identity=scope.actorId+":"+scope.organisationId;
  const seen=useRef({identity,allowed:false});
  if(seen.current.identity!==identity) {seen.current={identity,allowed:false};}
  const ready=!loading && !error && !!status;
  const required=status?.baselineRequired;
  const allowed=ready && !required;
  if(allowed) {seen.current.allowed=true;}
  return <>
    {/* Preserve a mounted player's in-memory state during a same-person refresh. */}
    <div key={identity} hidden={!allowed}>{seen.current.allowed?children:null}</div>
    {!ready && <section className="m-6 rounded-2xl border bg-white p-6" aria-label="Survey availability">
      {loading?<p role="status">Checking survey requirements…</p>:<>
        <p role="alert">We couldn't check your survey requirements. Please try again.</p>
        <button type="button" className="mt-4 rounded-lg bg-primary px-4 py-2 text-pd-cream" onClick={()=>void refetch()}>Try again</button>
      </>}
    </section>}
    {ready && required && <section className="m-6 rounded-2xl border bg-white p-6">
      <h1 className="text-h4 font-display font-bold">Take the five-minute baseline survey to open this lesson</h1>
      <Link className="mt-4 inline-block rounded-lg bg-primary px-4 py-2 text-pd-cream" to="/survey/start" state={{returnTo:location.pathname}}>
        Take the baseline survey
      </Link>
    </section>}
  </>;
}
